import { FC } from 'react';

import { TermOfUseAgentBpoReceives } from '@features/term_of_use_agent_bpo_receives';

const TermOfUseAgentBpoReceivesPage: FC = () => {
  return <TermOfUseAgentBpoReceives />;
};

export default TermOfUseAgentBpoReceivesPage;
